export const baseURL =
  process.env.REACT_APP_BACKEND_URL ?? "http://127.0.0.1:8000";
export const VERSION_NUMBER =
  process.env.REACT_APP_APPLICATION_VERSION_NUMBER ?? "Testing";
